import script from "./Bic.vue?vue&type=script&setup=true&lang=js"
export * from "./Bic.vue?vue&type=script&setup=true&lang=js"

import "./Bic.vue?vue&type=style&index=0&id=2b0380dc&scoped=true&lang=css"

import exportComponent from "../../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-2b0380dc"]])

export default __exports__